import { colors } from "../utils";
import { row } from "./row";

const _button = () => {
  return `     
    transition: all 300ms;
    cursor: pointer;
    display: block;
    text-align: center;

    :focus,
    :focus-visible {
        outline: none;
    }

    &[data-loading='true'] {
        cursor: not-allowed;
    }

    ${row("sm")};
  `;
};

export const buttonSolid = (color: string) => {
  return `        
    ${_button()};
    background-color: ${color};

    // === HOVERS CSS
    :hover {
        background-color: ${colors.luminance(color, -10)};
    }

    // ==== ACTIVE CSS
    :active {
      background-color: ${colors.luminance(color, -20)};
    }

    // ==== DISABLED CSS
    &[disabled],
    &[disabled]:hover,
    &[disabled]:active {
        background-color: #f3f3f3;
        border: 0px solid #f3f3f3;

        &,
        * {
            color: #a3a3a3;
        }
    }
  `;
};

export const buttonTransparent = (color = "#000000") => {
  return `          
    ${_button()};
    background-color: transparent;

    // === HOVERS CSS
    :hover {
      background-color: ${colors.opacity(color, 0.08)};
    }

    // ==== ACTIVE CSS
    :active {
      background-color: ${colors.opacity(color, 0.12)};
    }

    // ==== DISABLED CSS
    &[disabled],
    &[disabled]:hover,
    &[disabled]:active {
        background-color: #f3f3f3;
        border: 0px solid #f3f3f3;

        &,
        * {
            color: #a3a3a3;
        }
    }
  `;
};
